import axios from 'axios';

const state = {
	items: [],
	presets: null,
};

const getters = {
	getItems: state => state.items,
	getPresets: state => state.presets,
};

const auth = context => ({ headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } });
const url = (context, path) => `${context.rootGetters['settings/getUrl']}${path}`;

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		return axios
			.post(url(context, 'flyers'), { data: { sortBy: sortBy[0], sortDesc: sortDesc[0] ? 1 : 0, page, itemsPerPage, search: settings.search } }, auth(context))
			.then(res => {
				context.commit('setItems', res.data.data);
				return res.data.pagination;
			})
			.catch(err => console.log('errore', err));
	},
	fetchPresets: async context => {
		if (context.state.presets) return context.state.presets;
		const res = await axios.get(url(context, 'flyers/presets'), auth(context));
		context.commit('setPresets', res.data.data);
		return res.data.data;
	},
	getDetail: async (context, payload) =>
		axios
			.get(url(context, `flyers/${payload._id}`), auth(context))
			.then(res => res.data?.data)
			.catch(err => console.log('errore', err)),
	// salvataggio: gli errori arrivano al chiamante, che li mostra nella scheda
	save: async (context, form) => {
		const res = await axios.post(url(context, form._id ? 'flyers/update' : 'flyers/store'), form, auth(context));
		return res.data.data;
	},
	generate: async (context, payload) => axios.post(url(context, `flyers/${payload._id}/generate`), {}, auth(context)),
	preview: async (context, { form, lang }) => {
		const res = await axios.post(url(context, 'flyers/preview'), { data: form, lang }, auth(context));
		return res.data.data;
	},
	setUpdateStatusItem: async (context, payload) => axios.patch(url(context, 'flyers/status'), { data: payload }, auth(context)),
	deleteItem: async (context, payload) => axios.delete(url(context, `flyers/${payload._id}`), auth(context)),
	destroyData: context => {
		context.commit('setItems', []);
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setPresets: (state, value) => {
		state.presets = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
